<!--  -->
<template>
  <!-- 失效商品弹窗 -->
  <van-popup v-model="value"  @close="$emit('loadData')">
    <div class="failure-goods-popup">
      <div class="failure-goods-popup-header">
        失效商品
        <cc-svg-icon
          size=".21rem"
          @click="$emit('input', false)"
          class-name="xpt-close"
          icon-class="cancel-new"
          color="#dbdbdb"
        ></cc-svg-icon>
      </div>
      <p>以下商品已失效，将会移出采购车</p>
      <div class="failure-goods-popup-content">
        <div class="imgs">
          <img class="img" v-for="(item,index) in errorData.slice(0,5)" :key="index" :src="item || $notImg" alt="">
          <div class="img mask-box" v-if="errorData.length>5">
            <img :src="errorData[6] || $notImg" alt="">
            <div class="mask">共{{errorData.length}}条</div>
          </div>
        </div>
      </div>
      <div class="failure-goods-popup-footer">
        <div class="btn" @click="comfirm">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  components: {},

  props: {
    errorData: {
      type: Array,
      default: () => []
    },
    value: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
    }
  },

  computed: {},

  watch: {},

  created () {},

  methods: {
    comfirm () {
      this.$emit('input', false)
    }
  }
}

</script>
<style lang='scss' scoped>
/* 失效商品弹窗 */
.failure-goods-popup{
  height: 320px;
  width: 300px;
  display: flex;
  flex-direction: column;
  &-header{
    height: 45px;
    border: 1px solid rgba(229,229,229,1);
    position: relative;
    font-size: 15px;
    color: #333333;
    @include center();
    .xpt-close{
      position: absolute;
      top: 0;
      bottom: 0;
      right: 10px;
      margin: auto 0;
    }
  }
  p{
    color: #555555;
    padding: 17px 20px;
    font-size: 14px;
  }
  &-content{
    flex: 1;
    overflow: auto;
    padding:0 9px;
    box-sizing: border-box;
    .imgs{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .img{
        display: inline-block;
        width: 61px;
        height: 61px;
        margin: 0 14px 18px;
        img{
          width: 100%;
          height: 100%;
        }
        &:last-child:nth-child(3n - 1) {
          margin-right: 112px;
        }
      }
      .mask-box{
        position: relative;
        .mask{
          position: absolute;
          top:0;
          left:0;
          width: 100%;
          height: 100%;
          background:rgba(83,83,83,.5);
          color: #FFFFFF;
          font-size: 12px;
          @include  center();
        }
      }
    }
  }
  &-footer{
    height: 55px;
    display: flex;
    justify-content: center;
    .btn{
      width: 250px;
      height: 34px;
      border-radius: 17px;
      background: var(--APP_theme_color);
      @include center();
      color: #FFFFFF;
      font-size: 15px;
    }
  }
}
</style>
